declare let $: any;
declare let BASEURL: any
import { HelperFunctions } from './helpers/dom.helper'

const elements = {
    intro_home: $('#intro_home'),
    howItWorks: $('#how-it-works'),
    help: $('#help'),
    fullpage: $('#fullpage'),
    socialShare: $('.card-details-share--box'),
    form: $('form'),
    accordion: $('#accordion')
}

const Asset_URL = {
    'jquery': BASEURL + '/js/jquery-2.2.4.min.js',
    'owlcarousel': BASEURL + '/js/owl.carousel.2.0.0-beta.2.4/owl.carousel.js',
    'jqueryEasings': BASEURL + '/js/fullPage.js-master/vendors/jquery.easings.min.js',
    'scrolloverflow': BASEURL + '/js/fullPage.js-master/vendors/scrolloverflow.min.js',
    'jqueryFullPage': BASEURL + '/js/fullPage.js-master/jquery.fullPage.js',
    'modernizrCustom': BASEURL + '/js/Responsive-3D-Cover-Flow-Gallery-Plugin-with-jQuery/lib/modernizr.custom.js',
    'jqueryResponsiveGallery': BASEURL + '/js/Responsive-3D-Cover-Flow-Gallery-Plugin-with-jQuery/src/jquery.responsiveGallery.js',
    'intlTelInput': BASEURL + '/js/intl-tel-input/build/js/intlTelInput.min.js',
    'jqueryValidate': BASEURL + '/js/validation/dist/jquery.validate.min.js',
    'noty': BASEURL + '/js/jquery.noty.packaged.min.js',

   

}


HelperFunctions.ifExists('#intro_home', () => {
    $('#intro_home .intro-left').show();
    $('#intro_home .intro-left').addClass('animated fadeInUp');
})


HelperFunctions.ifExists('.alert', () => {
    HelperFunctions.loadScript(Asset_URL.noty, () => {
    // notification //
    var alertMessage = $(".alert").data('message')
    var alertType = $(".alert").data('type')
    var n = $('.alert').noty({
        text: alertMessage,
        type: alertType,
        theme: 'metroui',
        layout: 'topRight',
        timeout: 6000,
        progressBar: true,
        animation: {
            open: {
                height: 'toggle'
            }, // or Animate.css class names like: 'animated bounceInLeft'
            close: {
                height: 'toggle'
            }, // or Animate.css class names like: 'animated bounceOutLeft'
            easing: 'swing',
            speed: 500 // opening & closing animation speed
        },
        closeWith: ['click'], // ['click', 'button', 'hover', 'backdrop'] // backdrop click will close all notifications
        modal: false, // [boolean] if true adds an overlay
        killer: false, // [boolean] if true closes all notifications and shows itself
        callback: {
            onShow: function() {},
            afterShow: function() {},
            onClose: function() {},
            afterClose: function() {},
            onCloseClick: function() {},
        },
        buttons: false // [boolean|array] an array of buttons, for creating confirmation dialogs.
    });
});
});

HelperFunctions.ifExists('.how-it-works', () => {
    HelperFunctions.loadScript(Asset_URL.owlcarousel, () => {
        //how it works carousel
        $('.how-it-works .owl-carousel').owlCarousel({
            loop: true
            , autoHeight: true
            , margin: 10
            , responsiveClass: true
            , autoplay: true
            , autoplayTimeout: 6000
            , nav: false
            , animateIn: 'fadeIn'
            , animateOut: 'fadeOut'
            , smartSpeed: 100
            , items: 1
            , autoPlay: 3000, //Set AutoPlay to 3 seconds
            dots: true
            ,
        }).on('changed.owl.carousel', function (e) {
            let that = $(e.target)
            let index = e.page.index;
            let parent = that.parents('[id*="how-it-work"]').first()
            let item = parent.find('.mobile-frame#index' + index);
            item.addClass('active animated bounceInLeft').siblings().removeClass('active animated bounceInLeft');
        });
    })
})

if(!$('body').hasClass('webview'))
    {
HelperFunctions.ifExists('#fullpage', () => {
    HelperFunctions.loadScript(Asset_URL.jqueryEasings, () => {
        HelperFunctions.loadScript(Asset_URL.scrolloverflow, () => {
            HelperFunctions.loadScript(Asset_URL.jqueryFullPage, () => {
                // full page plugin
                $('#fullpage').fullpage({
                    fadingEffect: true,
                    parallax: true,
                    anchors: ['introduction', 'how_it_works', 'service_provider', 'Appfeatures', 'helpFAQ', 'contact_us','footerSection'],
                    menu: '#myMenu',
                    recordHistory: false,
                    loopHorizontal:false,
                   
                    onLeave: function (index, nextIndex, direction) {
                        if (index == 1 && direction == 'down') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('استخدم بنسل');
                            $('#how-it-work-user .mobile-frame').addClass('animated pulse');
                        }
                        if (index == 2 && direction == 'down') {
                            $('.header-menu-icon').addClass('white').removeClass('black hide');
                            $('.header-menu-title').text('لمقدمى الخدمات');
                            $('#how-it-work-tuts .mobile-frame').addClass('animated bounceInLeft');
                        }
                        if (index == 2 && direction == 'up') {
                            $('.header-menu-icon').addClass('white').removeClass('black hide');
                            $('.header-menu-title').text('');
                        }
                        if (index == 3 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('استخدم بنسل');

                        }
                        if (index == 3 && direction == 'down') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('مميزات بنسل');
                        }
                        if (index == 4 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('لمقدمى الخدمات');
                        }
                        if (index == 4 && direction == 'down') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('المساعدة');
                            $('#help .help-left img').addClass('animated flipInY');

                        }
                        if (index == 5 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('المساعدة');
                        }
                        if (index == 5 && direction == 'down') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('اتصل بنا');
                        }
                        if (index == 5 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('مميزات بنسل');
                        }
                        if (index == 6 && direction == 'down') {
                            $('.header-menu-icon').addClass('hide').removeClass('white black');
                            $('.header-menu-title').text(' ');
                        }
                        if (index == 6 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('المساعدة');
                        }
                        if (index == 7 && direction == 'up') {
                            $('.header-menu-icon').addClass('black').removeClass('white hide');
                            $('.header-menu-title').text('اتصل بنا');
                        }
                    }
                });
                if(window.matchMedia('(max-width:480px)')) {
                    $('#fullpage').fullpage.reBuild();
                }
            });
        });
    })
})
    }

HelperFunctions.ifExists('.card-details-share--box', () => {
    //share widget
    HelperFunctions.loadScript(BASEURL + '/front/node_modules/jssocials/dist/jssocials.js', () => {
        $(".card-details-share--box").jsSocials({
            shares: ["email", "twitter", "facebook", "googleplus", "linkedin", "pinterest", "stumbleupon", "whatsapp"]
            , showLabel: false
        });
    })
})


HelperFunctions.ifExists('form', () => {
    HelperFunctions.loadScript(Asset_URL.jqueryValidate, () => {

        $.validator.addMethod('customphone', function (value, element) {
            return this.optional(element) || /^\+[1-9]{1}[0-9]{3,14}$/.test(value);
        }, "الرجاء ادخال رقم الهاتف");
        // form validation
        $("form").validate({
            rules: {
                field: {
                    required: true
                }
                ,
                phone_number: 'customphone'
            }
            , messages: {
                full_name: " الرجاء إدخال الأسم"
                , email: " الرجاء إدخال البريد الإلكترونى "
                , phone_number: "الرجاء إدخال رقم الهاتف"
                , message: "الرجاء ادخال رسالتك"
                ,
            }
        })



    })
})

HelperFunctions.ifExists('#accordion', () => {
    // help page accordion
    $('#accordion #help_que').hide();
    $('#accordion .questions_container:first').parent().addClass('active');
    $('#accordion .questions_container:first').addClass('active').next().show();
    $('#accordion .questions_container').click(function (e) {
        let that = e.currentTarget;
        if ($(that).next().is(':hidden')) {
            $('#accordion .questions_container').removeClass('active').next().slideUp('slow');
            $(that).toggleClass('active').next().slideDown('slow');
            $('#accordion .questions_container').parent().removeClass('active');
            $(that).parent().addClass('active');
        }
        // var help_image = $(this).parent().attr('data-image');
        // $('.help-left img').css('background-image', 'url(' +help_image+ ')');
        e.preventDefault();
    });
})

HelperFunctions.ifExists('#phone, .tel, [type=tel]', () => {
    HelperFunctions.loadScript(Asset_URL.intlTelInput, () => {
        // internation phone number plugin
        $("#phone").intlTelInput({
               numberType: 'MOBILE',
                initialCountry: "eg",
                defaultCountry: "eg",
              
                nationalMode: false
        });

        
    })
})


HelperFunctions.ifExists('#features', () => {
    HelperFunctions.loadScript(Asset_URL.modernizrCustom, () => {
        HelperFunctions.loadScript(Asset_URL.jqueryResponsiveGallery, () => {
            $('.responsiveGallery-wrapper').responsiveGallery({
                animatDuration: 400, // ms
                $btn_prev: $('.responsiveGallery-btn_prev'),
                $btn_next: $('.responsiveGallery-btn_next')
            });
            // features card gallery
            $('.responsiveGallery-item:nth-child(4)').addClass('active');
            var responsiveGallery_child = $('.responsiveGallery-item.active').index() + 1;
            var li_desc = $(".responsiveGallery-item.active").attr('data-title');
            $('.responsivGallery-name').text(li_desc);
            $('.responsiveGallery-btn_next').click(function () {
                responsiveGallery_child = responsiveGallery_child + 1;
                if (responsiveGallery_child > 7) {
                    responsiveGallery_child = responsiveGallery_child - 6;
                }
                $(".responsiveGallery-item:nth-child(" + (responsiveGallery_child) + ")").addClass('active').siblings().removeClass('active');
                li_desc = $(".responsiveGallery-item.active").attr('data-title');
                $('.responsivGallery-name').text(li_desc);
            });
            $('.responsiveGallery-btn_prev').click(function () {
                responsiveGallery_child = responsiveGallery_child - 1;
                if (responsiveGallery_child < 2) {
                    responsiveGallery_child = responsiveGallery_child + 6;
                }
                $(".responsiveGallery-item:nth-child(" + (responsiveGallery_child) + ")").addClass('active').siblings().removeClass('active');
                li_desc = $(".responsiveGallery-item.active").attr('data-title');
                $('.responsivGallery-name').text(li_desc);
            });
        })
    })
})

$(document).ready($ => {
    $(window).load(function() {
		// Animate loader off screen
		$(".se-pre-con").fadeOut("slow");;
	});
    // help page scroll
    var topOfOthDiv = $("#footer").offset().top - 640;
    $(window).scroll(function () {
        if ($(window).scrollTop() > topOfOthDiv) {
            $(".help_page .help-left").addClass('notStatic');
        }
        else {
            $(".help_page .help-left").removeClass('notStatic');
        }
    });
    
    //Header toggle
    $('.header-menu-icon_open').on('click', function () {

        $('.header_intro').removeClass('hide');
    })
    $('.header-menu-icon_close').on('click', function () {
        $('.header_intro').addClass('hide');
    })
    $('nav li a').click(function () {
        $('.header_intro').addClass('hide');
    });
    $('#footer-scrollTop').click(function () {
        $.fn.fullpage.moveTo('introduction', 1);
    });
})


// WEBPACK FOOTER //
// ./src/script/main.ts